import type { ReactElement } from 'react';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { camelCase } from 'lodash';
import { friendlyRole, roleIconProp } from 'helpers/domain-specific/role.helpers';
import type { ROLE } from 'services/assist-api/entities/role/roles';
import styles from './role-badge.module.scss';

/**
 * Role Badge
 *
 * Takes a role string, and displays a pill/badge with user friendly text, icons, and colour.
 * Aims to make display of a users role consistent and identifiable
 */
export default function RoleBadge({ role }: { role: ROLE }): ReactElement | null {
  const displayName = friendlyRole(role);
  const iconProp = roleIconProp(role);
  return displayName ? (
    <span className={clsx('badge text-light rounded-pill px-4', styles[camelCase(displayName)])}>
      {displayName}
      {iconProp && (
        <span className="ps-2">
          <FontAwesomeIcon icon={iconProp} />
        </span>
      )}
    </span>
  ) : null;
}
